import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import '../../css/layout.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCopy,
  faCog,
  faChartLine,
  faImage,
  faCaretDown,
  faFileContract,
  faFingerprint,
  faClipboardList,
  faCaretUp,
  faMobileAlt,
  faQuestionCircle,
  faScroll,
  faImages
} from '@fortawesome/free-solid-svg-icons';
import waaLogo from '../../assets/waa-logo.png';
import waaNewLogo from '../../assets/waa-new-logo.png';
import { Cache } from 'aws-amplify';

class SideNavbar extends Component {

  constructor(props) {
    super(props);
    this.roleId = '';
    this.subMenuClass = "submenu-link";
  }

  componentDidMount() {

    this.displayDownCaret = "inline";

    //show reports links if on a reports page
    const pathname = this.props.location.pathname;
    if (pathname.includes('/reports')) {
      this.toggleReportsMenu();
    }

    if (pathname.includes('/settings')) {
      this.toggleSettingsMenu();
    }

  }

  toggleReportsMenu = () => {
    document.getElementsByClassName("reports caret-up-icon")[0].style.display = this.displayDownCaret;
    this.displayDownCaret = (this.displayDownCaret === 'none') ? 'inline' : 'none';
    document.getElementsByClassName("reports caret-down-icon")[0].style.display = this.displayDownCaret;

    Array.from(document.getElementsByClassName("reports-sub-menus")).forEach(element => {
      element.style.display = (element.offsetParent === null) ? 'block' : 'none';
    });
  }

  toggleSettingsMenu = () => {
    document.getElementsByClassName("settings caret-up-icon")[0].style.display = this.displayDownCaret;
    this.displayDownCaret = (this.displayDownCaret === 'none') ? 'inline' : 'none';
    document.getElementsByClassName("settings caret-down-icon")[0].style.display = this.displayDownCaret;

    Array.from(document.getElementsByClassName("settings-sub-menus")).forEach(element => {
      element.style.display = (element.offsetParent === null) ? 'block' : 'none';
    });
  }

  displaySettingsLink = (setting, key) => {
    return (
      <Link to="#" className={"settings-sub-menus " + this.subMenuClass} key={key} onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/settings' + setting.link);
      }}>
        {setting.name}
      </Link>
    )
  }

  displaySettingsMenu = () => {
    let settingsLinks = [
      // { link: '/users', name: 'Users' },
      { link: '/admins', name: 'Admin Users' },
      //TODO: UNHIDE THIS
      //{ link: '/roles-permissions', name:'Roles & Permissions' }, 
      //{ link: '/company',           name:'Company' }, 
    ];

    const settingsList = settingsLinks.map((setting, key) => this.displaySettingsLink(setting, key));

    return (
      <>
        <Link to="#" onClick={(e) => {
          e.preventDefault();
          this.toggleSettingsMenu();
        }}>
          <FontAwesomeIcon icon={faCog} /> Settings <FontAwesomeIcon className="settings caret-down-icon" icon={faCaretDown} /><FontAwesomeIcon className="settings caret-up-icon" icon={faCaretUp} />
        </Link>
        {settingsList}
      </>
    )
  }

  displaySubmenu = (parent, menuItem, key) => {
    return (
      <Link to="#" className={parent + "-sub-menus " + this.subMenuClass} key={key} onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/' + parent + '/' + menuItem.link);
      }}>
        {menuItem.name}
      </Link>
    )
  }

  toggleMenu = (menuName) => {
    document.getElementsByClassName("caret-up-icon")[0].style.display = this.displayDownCaret;
    this.displayDownCaret = (this.displayDownCaret === 'none') ? 'inline' : 'none';
    document.getElementsByClassName("caret-down-icon")[0].style.display = this.displayDownCaret;

    Array.from(document.getElementsByClassName(menuName + '-sub-menus')).forEach(element => {
      element.style.display = (element.offsetParent === null) ? 'block' : 'none';
    });
  }

  displayReportsMenu = () => {
    const menuName = "reports";
    let reportLinks = [
      { link: 'usage-statistics', name: 'Usage Statistics' },
    ]

    const reportsList = reportLinks.map((report, key) => this.displaySubmenu(menuName, report, key));

    return (
      <>
        <Link to="#" onClick={(e) => {
          e.preventDefault();
          this.toggleMenu(menuName);
        }}>
          <FontAwesomeIcon icon={faClipboardList} /> Reports <FontAwesomeIcon className={menuName + " caret-down-icon"} icon={faCaretDown} /><FontAwesomeIcon className={menuName + " caret-up-icon"} icon={faCaretUp} />
        </Link>
        {reportsList}
      </>
    )
  }

  displayDashboard = () => {
    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/dashboard');

      }}>
        <FontAwesomeIcon icon={faChartLine} /> Dashboard
      </Link>
    )
  }

  displayPostsMenu = () => {

    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/posts');

      }}>
        <FontAwesomeIcon icon={faCopy} /> Posts / Announcements
      </Link>
    )
  }

  displayWAATermsMenu = () => {

    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/terms/edit');

      }}>
        <FontAwesomeIcon icon={faFileContract} /> WAA EULA & Privacy Policy
      </Link>
    )
  }
  displayAcentivesTermsMenu = () => {

    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/privacy-policy/edit');

      }}>
        <FontAwesomeIcon icon={faFingerprint} /> Acentives EULA & Privacy Policy
      </Link>
    )
  }

  displayFAQsMenu = () => {

    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/faqs/edit');

      }}>
        <FontAwesomeIcon icon={faQuestionCircle} /> FAQ's
      </Link>
    )
  }

  displaySendNotificationMenu = () => {

    return false;

    // return (
    //   <Link to="#" onClick={(e) => {
    //     e.preventDefault();
    //     this.props.history.push('/send-notification');

    //   }}>
    //     <FontAwesomeIcon icon={faBullhorn} /> Send Notification
    //   </Link>
    // )
  }

  displaySplashScreensMenu = () => {

    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/splash-screens');

      }}>
        <FontAwesomeIcon icon={faImage} /> Splash Screens
      </Link>
    )
  }

  displayMobileAppBanner = () => {

    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/mobile-app-banner');

      }}>
        <FontAwesomeIcon icon={faImages} /> Mobile App Banner
      </Link>
    )
  }

  displayAppVersions = () => {

    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/app-versions');

      }}>
        <FontAwesomeIcon icon={faScroll} /> App Versions
      </Link>
    )
  }

  displayAsuiteApps = () => {

    return (
      <Link to="#" onClick={(e) => {
        e.preventDefault();
        this.props.history.push('/asuite-apps');

      }}>
        <FontAwesomeIcon icon={faMobileAlt} /> A-Suite Apps
      </Link>
    )
  }

  render() {
    this.roleId = Cache.getItem('roleId');
    return (
      <React.Fragment>
        <div className="sidenav">
          <img className="company-logo" src={waaNewLogo} alt="waa-logo" width="100%" height="auto" />
          {this.displayDashboard()}
          {this.displayPostsMenu()}
          {this.displayWAATermsMenu()}
          {this.displayAcentivesTermsMenu()}
          {this.displayFAQsMenu()}
          {this.displaySendNotificationMenu()}
          {this.displaySplashScreensMenu()}
          {this.displayAppVersions()}
          {this.displayMobileAppBanner()}
          {this.displayAsuiteApps()}
          {this.displayReportsMenu()}
          {this.displaySettingsMenu()}
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users
})

export default withRouter(connect(mapStateToProps)(SideNavbar))